import {useNavigate, useSearchParams} from "react-router-dom";
import Grid from "@mui/material/Grid";
import * as React from "react";
import {useEffect, useState} from "react";
import useRootHook from "../../hooks/useRoot";
import helpers from "../../helpers/common";
import PayoutMethodForm from "./PayoutMethodForm";
import methods from "../../models/payout-methods";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function PayoutMethodEdit() {
    const [searchParams] = useSearchParams();
    const [payoutMethodData, setPayoutMethodData] = useState(null)
    const [fields, setFields] = useState({})
    const [errors, setErrors] = useState({});
    const {setShowLoader} = useRootHook();
    const navigate = useNavigate()

    useEffect(() => {
        setShowLoader(true)
        methods.get(searchParams.get('id'))
            .then((data) => {
                setShowLoader(false)
                data && setPayoutMethodData(data)
                data && setFields(data)
            }).catch(() => setShowLoader(false))

    }, [])

    const handleChange = (ev) => {
        const [, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [, , name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof methods.fieldValidator[name] === 'function'
        && methods.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = methods.methodValidator.edit(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        methods.edit(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/payout-methods')
            }).catch(() => setShowLoader(false))
    }

    if (!payoutMethodData) return null

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title={`Edit payout method: ${payoutMethodData.name}`} breadcrumbs={[['Dashboard', '/'], ['Payout Methods', '/payout-methods'], ['Edit', `/payout-methods/edit?id=${payoutMethodData.id}`]]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <PayoutMethodForm fields={fields} errors={errors} handleChange={handleChange}
                                  handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}